<template>
  <div class="box">
    <day title="视频数据概览" @addDay="addDay" :dayNum="dayNum"></day>
    <div class="border">
      <div></div>
    </div>
    <tablist :info="listTab"></tablist>
   <div class="chart">
    <div class="box_list">
      <topTitle title="视频发布日历" icon="https://s6.bihukankan.com/Group%204883.svg" @checked="checked_1"></topTitle>
      <videoDay :dayNum="dayNum" :onlySales="onlySales_1"></videoDay>
    </div>
    <div class="box_list">
      <topTitle title="近30个作品表现" icon="https://s6.bihukankan.com/Group%204886.svg" @checked="checked_2"></topTitle>
      <tab title="作品热度趋势">
        <template>
        <div class="but_box">
          <div class="but" @click="worksMuen('views')" :class="worksStr == 'views' ? 'but_n' : ''">播放量</div>
          <div class="but" @click="worksMuen('likes')" :class="worksStr == 'likes' ? 'but_n' : ''">点赞量</div>
          <div class="but" @click="worksMuen('comments')" :class="worksStr == 'comments' ? 'but_n' : ''">评论量</div>
        </div>
        </template>
      </tab>
      <works :dayNum="dayNum" :onlySales="onlySales_2" :worksStr="worksStr"></works>
    </div>
    <div class="box_list">
      <tab title="作品发布时间">
        <template>
        <div class="openTime">
          <div style="width: 8px;height: 8px;background: linear-gradient(180deg, rgba(40, 119, 255, 0.85) 0%, rgba(40, 119, 255, 0.51) 100%);margin-right: 5px;"></div>
          <span>该时段发布作品</span>
        </div>
        </template>
      </tab>
      <worksTime :dayNum="dayNum"></worksTime>
    </div>
    <div class="box_list">
      <tab title="作品时长"></tab>
      <worksTimeOpen :dayNum="dayNum"></worksTimeOpen>
    </div>
   </div>
    <div class="works_list">
      <tab title="作品列表">
        <template>
        <div class="check">
          <van-checkbox :icon-size="16" v-model="params.onlySales" shape="square" checked-color="#2877FF" @change="change">
            <span :class="checkBox()">只看带货视频</span>
          </van-checkbox>    
          <div class="but_box">
          <div class="but_list" @click="worksList('releaseTime')" :class="params.sort == 'releaseTime' ? 'but_n_l' : ''">最新发布</div>
          <div class="but_list" @click="worksList('views')" :class="params.sort == 'views' ? 'but_n_l' : ''">最多播放</div>
         </div>
        </div>
        </template>
      </tab>
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText"  @load="getList()">
        <div v-for="(item,index) in listData">
          <list  :key="index" :info="item" :index="index + 1"></list>
        </div>
    </van-list>
    <LoginOrPayView v-if="!isVip" vip-text="升级版本权益后<br/>即可查看更多数据和使用更多功能" />
    </div>
  </div>
</template>

<script>
import day from '../components/day'
import tablist from '../components/tablist'
import videoDay from './components/videoDay'
import works from './components/works'
import worksTime from './components/worksTime'
import worksTimeOpen from './components/worksTimeOpen'
import topTitle from './components/topTitle.vue'
import tab from './components/tab.vue'
import list from '@/modules/Delivery/list.vue'
const today = new Date();
const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
const formattedYesterday = `${yesterday.getFullYear()}${String(yesterday.getMonth() + 1).padStart(2, '0')}${String(yesterday.getDate()).padStart(2, '0')}`;
export default {
 components:{day,tablist,videoDay,works,worksTime,worksTimeOpen,topTitle,tab,list},
  data() {
    return {
        checked:false,
        dayNum:30,
        totalOpus:{},
        videoData:{},
        onlySales_1:false,
        onlySales_2:false,
        worksStr:'views',
        count:0,
        params:{
        page:25,
        index:1,
        sort:'releaseTime',
        order:'desc',
        onlySales:false
      },
      listData:[],
      loading:false
    }
  },
  mounted() {
    this.getInfo()
    this.getList()
  },
  methods: {
    worksList(val) {
      this.listData = []
      this.count = 0
      this.params.index = 1
      this.params.sort = val
      this.getList()
    },
    change() {
        this.listData = []
        this.count = 0
        this.params.index = 1
        this.getList()
    },
    checkBox() {
     return  this.params.onlySales ? 'color' : ''
    },
    worksMuen (val) {
      this.worksStr = val
    },
    checked_1(val) {
      this.onlySales_1 = val
    },
    checked_2(val) {
      this.onlySales_2 = val
    },
    addDay(val) {
        this.dayNum = val
        this.getInfo()
    },
    getList() {
      this.loading = true
      this.$get({
          road: 'opusAnchor',
          data: { anchorId: this.$route.params.id },
          params:this.params, 
          version:'v2'
        })
        .then(res=>{
          this.$toast.clear()
          this.count = res.paging.count
          this.listData = [...this.listData,...res.data]
          this.loading = false
          this.params.index++
        })
    },
    getInfo() {
      this.$showLoading()
      this.$get({
          road: 'opusStatistic',
          data: { anchorId: this.$route.params.id },
          params: { timeMode: this.dayNum, time: formattedYesterday },
          version: 'v22'
        }).then(res => {
         this.totalOpus = res.data.totalOpus
        }).finally(() => {
          this.$toast.clear()
        })
    }
  },
  computed:{
    finished(){
      return this.count === this.listData.length
    },
    isVip(){
      return this.$store.state.userLevel && this.$store.state.userLevel < 1000
    },
    finishedText: ( _this = this) => ( !_this.isVip ? '升级权益查看更多数据' : '没有更多了'),
    listTab() {
      return [
        [
          {text:'发布作品',value:this.$retainWan(this.totalOpus.opusCount)},
          {text:'平均播放',value:this.$retainWan(this.totalOpus.avgViews)},
          {text:'平均点赞',value:this.$retainWan(this.totalOpus.avgLikes)},
          {text:'平均评论',value:this.$retainWan(this.totalOpus.avgComments)},
        ]
      ]
    }
  },
  
}
</script>

<style scoped lang='less'>
/deep/
.color {
  color: #2877FF
}
.box {
    .border {
    height: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      width: 351px;
      height: 0.5px;
      background-color: #EDEDEE;
    }
  }
  .chart {
    margin-top: 12px;
    .box_list {
      margin-bottom: 12px;
      background-color: #fff;
      .openTime {
        display: flex;
        align-items: center;
        font-size: 12px;
        color:#696D75
      }
      .but_box {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .but {
          display: flex;
          width: 58px;
          height: 24px;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color:#858A90
        }
        .but_n {
          border-radius: 2px;
          background-color: #E9F1FF;
          color:#2877FF ;
        }
      }
  }
  }

  .works_list {
    margin-top: 12px;
    .check {
      display: flex;
      .but_box {
        margin-left: 10px;
        width: 130px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .but_list {
          display: flex;
          width: 65px;
          height: 24px;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color:#858A90
        }
        .but_n_l {
          border-radius: 2px;
          background-color: #E9F1FF;
          color:#2877FF ;
        }
      }
    }
  }
}
</style>
